import React from 'react'
import { type VideoContext } from '@/types/cms'

const StructuredData = ({ item }: { item: VideoContext }) => {
  const jsonLd = {
    '@context': 'http://schema.org',
    '@type': 'VideoObject',
    datePublished: item.model.publishedAt,
    uploadDate: item.model.publishedAt,
    dateModified: item.model.updatedAt,
    name: item.model.kicker + ' - ' + item.model.title + ' - Video - ntv',
    description: item.model.leadtext,
    ...(item.model.image
      ? {
          thumbnailUrl: item.model.image.baseUrl + 'Img_16_9/400/' + item.model.image.filename + '.webp',
        }
      : { thumbnailUrl: 'https://www.n-tv.de/logo_grey.svg' }),
    contentUrl: item.model.video.botUrl ? item.model.video.botUrl : item.model.url,
    ...(item.model.fields.transcript ? { transcript: item.model.fields.transcript } : {}),
  }

  return (
    <>{jsonLd && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />}</>
  )
}

export default StructuredData
